import React from 'react';
import { BRAND, isMarketGB } from '../../../constants/main';
import { BasketUserDetailsAC } from './AC/BasketUserDetails.AC';
import { BasketUserDetailsOV } from './OV/BasketUserDetails.OV';
import { BasketUserDetailsAP } from './AP/BasketUserDetails.AP';
import { BasketUserDetailsDS } from './DS/BasketUserDetails.DS';
import { BasketUserDetailsOV as BasketUserDetailsOV_GB } from './OV/GB/BasketUserDetails.OV';
import { BasketUserDetailsStyled } from './BasketUserDetailsStyled';
import { SC } from '../../../styles/theme';

export type BasketUserDetailsProps = SC & {
    generatedIndex?: number;
};

const BasketUserDetails = (props: BasketUserDetailsProps) => {
    if (BRAND === 'AC') return <BasketUserDetailsAC {...props} />;
    if (BRAND === 'OV') return isMarketGB ? <BasketUserDetailsOV_GB {...props} /> : <BasketUserDetailsOV {...props} />;
    if (BRAND === 'AP') return <BasketUserDetailsAP {...props} />;
    if (BRAND === 'DS') return <BasketUserDetailsDS {...props} />;
    return <BasketUserDetailsStyled {...props} />;
};

export default BasketUserDetails;
